export default __webpack_public_path__ + "static/media/bg-1.47e7e740.png";